module.exports = __webpack_public_path__ + "static/media/phone-connected.33d2a321.png";